<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student.show,
                    },
                    {
                        name: $tc('messages.comments', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.students"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <TitleFieldsFormSection class="mt-5" v-for="studentFile in studentFiles" :key="studentFile.id">
            <template v-slot:title>
                <div>{{ studentFile.year_range }}</div>
                <div class="inline-flex items-center">
                    <img
                        v-if="studentFile.image_path"
                        :alt="$t('messages.photo')"
                        :src="studentFile.image_path"
                        class="mx-auto rounded-full h-32 w-32 border-4 border-white"
                    />
                </div>
            </template>

            <div class="w-full flex space-x-4 justify-end" v-if="studentFile.can.create">
                <AppButton :href="meta.links.create">
                    {{ $t('messages.create') }}
                </AppButton>
            </div>

            <div class="flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider hidden md:block"
                                    >
                                        {{ $tc('messages.teachers', 1) }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.comment') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        <span class="sr-only">{{ $t('messages.actions') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="(student_file_comment, index) in studentFile.comments"
                                    :key="student_file_comment.id"
                                >
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 hidden md:block"
                                    >
                                        <div>
                                            {{ student_file_comment.teacher.full_name }}
                                        </div>
                                        <div>
                                            {{ student_file_comment.date }}
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                                        <p v-html="student_file_comment.comment" />
                                        <div class="md:hidden mt-5">
                                            <div class="text-gray-600">
                                                {{ student_file_comment.teacher.full_name }}
                                            </div>
                                            <div>
                                                {{ student_file_comment.date }}
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                    >
                                        <InertiaSquareLinkButton
                                            action="edit"
                                            :href="student_file_comment.links.edit"
                                            v-if="student_file_comment.can.update"
                                        />
                                        <InertiaSquareDeleteButton
                                            v-if="student_file_comment.links.delete && student_file_comment.can.delete"
                                            :href="student_file_comment.links.delete"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import AppButton from '@/components/AppButton.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        ActivityMenuOptions,
        AppButton,
        TitleFieldsFormSection,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'studentFiles', 'filters', 'student'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
